import { centsToUah, uahToCents } from './formatters';

export function toFormString(value?: string | number | null) {
  return String(value ?? '');
}

export function toFormStrings(values?: (string | number)[] | null) {
  return values?.map(String) ?? [];
}

export function toFormBoolean(value?: boolean | null, fallback = false) {
  return value ?? fallback;
}

export function toFormUah(cents?: number | null) {
  return cents == null ? '' : centsToUah(cents).toFixed(2);
}

export function fromFormUah(value: string) {
  return value === '' ? null : uahToCents(value);
}

const OPTION_INDENT = '    ';

export function indentOptionLabel(label: string, depth: number) {
  return `${OPTION_INDENT.repeat(depth)}${label}`;
}

export function withDestroyedAttributes<T extends { id?: number }>(
  rows: T[],
  originalIds: number[],
) {
  const keptIds = new Set(rows.map((row) => row.id));
  const destroyed = originalIds
    .filter((id) => !keptIds.has(id))
    .map((id) => ({ id, _destroy: true }));

  return [...rows, ...destroyed];
}
